// extracted by mini-css-extract-plugin
export default {"content":"ModalAddress_content__Q3H9V","mobileContent":"ModalAddress_mobileContent__pzurD","desc":"ModalAddress_desc__a4Qqr"};